import api from "./base-api"

const clockmakerSocialApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        isCheaterV1Cm: build.query({
            query: (userId) => `v1/cm/cheaters/${userId}`,
            providesTags: ["cm-cheater"]
        }),
        banV1Cm: build.mutation({
            query: ({ userId, reason }) => ({
                url: `v1/cm/cheaters/${userId}/ban`,
                method: "POST",
                body: reason
            }),
            invalidatesTags: ["cm-cheater"]
        }),
        unbanV1Cm: build.mutation({
            query: ({ userId, reason }) => ({
                url: `v1/cm/cheaters/${userId}/unban`,
                method: "POST",
                body: reason
            }),
            invalidatesTags: ["cm-cheater"]
        })
    }),
    overrideExisting: false
})

export const {
    useIsCheaterV1CmQuery,
    useBanV1CmMutation,
    useUnbanV1CmMutation
} = clockmakerSocialApiV1
